<template>
  <div class="dice" :class="{hit: isHit, glitch: isGlitch}">{{result}}</div>
</template>

<script>
import { isHit, isGlitch } from "@/utils";

export default {
  name: "Dice",
  props: {
    dice: {
      result: Number,
      sides: Number
    }
  },
  computed: {
    result() {
      return this.dice.result;
    },
    isHit() {
      return isHit(this.dice);
    },
    isGlitch() {
      return isGlitch(this.dice);
    }
  }
};
</script>

<style>
div.dice {
  margin: 5px;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 12vw;
  height: 12vw;

  font-size: 16px;

  border-radius: 2px;
  -moz-box-shadow: inset 0 0 10px #808080;
  -webkit-box-shadow: inset 0 0 10px #808080;
  box-shadow: inset 0 0 10px #808080;

  background-color: #313131;
}
div.dice.hit {
  background-color: #3a4d3d;
}
div.dice.glitch {
  background-color: #5a4646;
}

@media only screen and (min-width: 768px) {
  div.dice {
    font-size: 24px;
  }
}

@media only screen and (min-width: 992px) {
  div.dice {
    width: 6vw;
    height: 6vw;
  }
}

@media only screen and (min-width: 1200px) {
  div.dice {
    font-size: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dice.vue